import React, { useState } from 'react';
import SelectCompany from './selectCompanyView';
import type { Company } from '../../../../../models/companies/company';

type Field = {
  id: number;
  companyId: number | null;
};

type BuyWish = {
  companyId: number;
};

type Props = {
  companies: Array<Company>;
  defaultData: Array<BuyWish>;
};

export default function SelectCompaniesToBuyView(props: Props) {
  const { companies, defaultData } = props;

  const convertToFields = (buyWishes: Array<BuyWish>): Array<Field> => {
    return buyWishes.map((buyWish, i) => ({
      id: i,
      companyId: buyWish.companyId,
    }));
  };

  const [fields, setFields] = useState<Array<Field>>(
    convertToFields(defaultData),
  );

  const onAddField = () => {
    let nextID = 0;
    if (fields.length > 0) {
      nextID = fields[fields.length - 1].id + 1;
    }

    setFields([
      ...fields,
      {
        id: nextID,
        companyId: null,
      },
    ]);
  };

  const onRemoveField = (id: number) => {
    setFields(fields.filter(c => c.id !== id));
  };

  return (
    <div className="select-buy-form-wrapper">
      {fields.map(field => (
        <fieldset
          key={field.id}
          id={`fundinno_company_to_buy_${field.id}`}
          className="fieldset-row"
        >
          <SelectCompany
            companies={companies}
            inputName={`market_demand_questionnaire[fundinno_stock_buy_wishes_attributes][${field.id}][company_id]`}
            className="company-select"
            defaultCompanyId={field.companyId}
            placeholder="FUNDINNO銘柄"
          />
          <button
            type="button"
            onClick={() => onRemoveField(field.id)}
            className="icon-button"
          >
            <i className="fas fa-minus-circle" />
          </button>
        </fieldset>
      ))}
      <button
        type="button"
        onClick={() => onAddField()}
        className="icon-button"
      >
        <i className="fas fa-plus-circle" />
      </button>
    </div>
  );
}
